export default __webpack_public_path__ + "static/media/Vector334.2c1179b2.png";